import { render } from "./SupplierInvoice.vue?vue&type=template&id=09a45137&scoped=true"
import script from "./SupplierInvoice.vue?vue&type=script&lang=js"
export * from "./SupplierInvoice.vue?vue&type=script&lang=js"

import "./SupplierInvoice.vue?vue&type=style&index=0&id=09a45137&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a45137"]])

export default __exports__